import React from 'react';

import SelectControlled from '../SelectControlled';

import { MONTHS } from './constants';

function SelectMonthControlled({ ...props }) {
  const renderMonths = MONTHS.map(month => (
    <option key={month.value} value={month.value}>
      {month.label}
    </option>
  ));
  return (
    <SelectControlled options={renderMonths} defaultValue={0} {...props} />
  );
}

export default SelectMonthControlled;
